import {
    SAVE_VIDEO,
    RESET_VIDEO
} from './actions';

export const initialState = {
    video: '',
};

const videoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_VIDEO:
            return {
                ...state,
                video: action.video
            }
        case RESET_VIDEO:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default videoReducer;